import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-relative light-light-background max-height"
}
const _hoisted_2 = { class: "max-width" }
const _hoisted_3 = { class: "product-details-grid" }
const _hoisted_4 = {
  class: "octo-gradient-purple-color fw-b fs-larger",
  style: {"grid-area":"title"}
}
const _hoisted_5 = { class: "fw-b mobile-smaller" }
const _hoisted_6 = { class: "mobile-smaller" }
const _hoisted_7 = { class: "fw-b mobile-smaller" }
const _hoisted_8 = { class: "mobile-smaller" }
const _hoisted_9 = { class: "fw-b mobile-smaller" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "fw-b fs-smaller" }
const _hoisted_12 = { class: "fs-smaller" }
const _hoisted_13 = {
  key: 3,
  class: "d-flex",
  style: {"grid-column":"span 2"}
}
const _hoisted_14 = { class: "center-y my-3 flex-grow-1" }
const _hoisted_15 = {
  class: "highlight-box w-mc px-2 fs-smaller fw-600 light-light-color highlight-bg-coral card-border",
  style: {"padding-top":"2px","padding-bottom":"2px"}
}
const _hoisted_16 = {
  key: 0,
  class: "fw-b fs-larger center-y"
}
const _hoisted_17 = {
  key: 1,
  class: "fw-b fs-larger center-y"
}
const _hoisted_18 = {
  key: 4,
  style: {"grid-column":"span 2"}
}
const _hoisted_19 = {
  class: "d-flex center-y",
  style: {"gap":"5px"}
}
const _hoisted_20 = { class: "center-y" }
const _hoisted_21 = { class: "fw-b" }
const _hoisted_22 = { class: "fw-b" }
const _hoisted_23 = { class: "d-flex tags-container" }
const _hoisted_24 = { class: "center" }

import { IonCol, IonGrid, IonIcon, IonInput, IonRow, modalController } from "@ionic/vue";
import { computed, ref } from "vue";

import InputAmount from "@/components/input/InputAmount.vue";
import ButtonDelete from "@/components/button/ButtonDelete.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";
import CategoryPill from "@/components/various/CategoryPill.vue";
import ImageProduct from "@/components/various/ImageProduct.vue";

import { useUserStore } from "@/stores/user";
import { usePersistentStore } from "@/stores/persistent";

import { convertNumberWithComma } from "@/functions/converter";
import { isApp } from "@/functions/enviroment";

import { BUTTON_FILL, INPUT_TYPE, ION_VARIANT } from "@/types/enum/ionicEnum";
import { HIGHLIGHT_COLOR, HIGHLIGHT_MESSAGE } from "@/types/enum/propEnum";
import { PERMISSION_KEY } from "@/types/user";
import { CatalogProductProps } from "@/types/props";
import { CatalogProductEmits } from "@/types/emits";
import HighlightBox from "@/components/card/HighlightBox.vue";
import { requiresPermission } from "@/functions/check";

import { useNotificationStore } from "@/stores/notification";
import DashboardPromotionProduct from "@/components/modal/modalControllerModals/DashboardPromotionProduct.vue";
import { log } from "node:console";

export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogProduct',
  props: {
    product: {},
    catalog: { type: Boolean },
    contained: { type: Boolean },
    amount: {},
    showTags: { type: Boolean },
    tags: {},
    buttons: { type: Boolean },
    readOnly: { type: Boolean },
    targetStock: {},
    privateSupplier: { type: Boolean }
  },
  emits: ["back", "addList", "addCart", "amount", "delete", "tags", "openCatalog", "targetAmount", "edit-item"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const userStore = useUserStore()
const persistentStore = usePersistentStore()

const amountModel = computed<number>({
    get: () => {
        return props.amount ?? 0
    },
    set: (value) => {
        emit('amount', value)
    }
})

const select = async (event: Event): Promise<void> => {
    const target = event.currentTarget as HTMLIonInputElement;

    const input = await target.getInputElement();
    input.focus();
    input.select();
};

/* code from Ihor */
// clear input of chars and floats
const amountInput = ref();

const saveTargetInput = (event: CustomEvent): void => {
	// emit('targetAmount', Number(event.detail.value))
    const convertedNumber = Number(String(event.detail.value).replace(/[^0-9]*/g, ''));
    emit('targetAmount', Number(convertedNumber))
    amountInput.value.$forceUpdate()
}
/* end of code from Ihor */

const isMax = computed<boolean>(() => {
    return props.product.amountMax ? amountModel.value <= props.product.amountMax : true
})

const isMultiple = computed<boolean>(() => {
    return (amountModel.value % (props.product.amountStep ?? 1)) === 0
})

const fullWidth = computed<boolean>(() => {
    return props.catalog || !userStore.permission[PERMISSION_KEY.LIST_ITEM_DELETE]
})

const verticalVersion = ref<boolean>(isApp() && !window.matchMedia("(orientation: landscape)").matches)
window.addEventListener('orientationchange', () => verticalVersion.value = isApp() && !window.matchMedia("(orientation: landscape)").matches)
window.addEventListener('resize', () => verticalVersion.value = isApp() && !window.matchMedia("(orientation: landscape)").matches)

const notificationStore = useNotificationStore();

const openProductDetails = async (informationId: string): Promise<void> => {
    const promotionIndex = notificationStore.allPromotions.findIndex((promotion) => promotion.item.id === informationId)

    if (promotionIndex === -1) return

    notificationStore.currentInformationIndex = promotionIndex

    await (await modalController.create({
        component: DashboardPromotionProduct,
        cssClass: 'product-information-modal'
    })).present()
}

return (_ctx: any,_cache: any) => {
  return (__props.product)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (verticalVersion.value)
          ? (_openBlock(), _createBlock(ImageProduct, {
              key: 0,
              "image-link": __props.product.imageLink,
              class: "contain-within-300"
            }, null, 8, ["image-link"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(IonGrid), {
          class: _normalizeClass(["purple-purple-color d-flex flex-d-c flex-grow-1 max-width", {'max-height': !verticalVersion.value, 'mt-3': verticalVersion.value}])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), { class: "max-height mb-5" }, {
              default: _withCtx(() => [
                (!verticalVersion.value)
                  ? (_openBlock(), _createBlock(_unref(IonCol), {
                      key: 0,
                      class: "center adapt-image"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ImageProduct, {
                          "image-link": __props.product.imageLink
                        }, null, 8, ["image-link"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonCol), { class: "center max-width" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.product.name), 1),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('label.category')) + ":", 1),
                        _createElementVNode("div", _hoisted_6, _toDisplayString((__props.product.itemGroup2) ? `${__props.product.itemGroup1} / ${__props.product.itemGroup2}` : `${__props.product.itemGroup1}`), 1),
                        (__props.product.itemNumber)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('label.articleNo')) + ":", 1),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(__props.product.itemNumber), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (__props.product.promotions?.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('object.promotion', __props.product.promotions.length)) + ":", 1),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.promotions, (promotion) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: promotion.id,
                                    class: "mobile-smaller link",
                                    onClick: _withModifiers(($event: any) => (openProductDetails(promotion.id)), ["stop"])
                                  }, _toDisplayString(promotion.title), 9, _hoisted_10))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (__props.product.notInStock)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.availability')) + ":", 1),
                              _createElementVNode("div", _hoisted_12, _toDisplayString(__props.product.availabilityInformation) + " (" + _toDisplayString(_ctx.$t(`enumT.${_unref(HIGHLIGHT_MESSAGE).NOT_IN_STOCK}`)) + ") ", 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (__props.product.packaging)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, _toDisplayString(__props.product.packaging), 1)
                              ]),
                              (__props.product.unitPrice)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(convertNumberWithComma)(__props.product.unitPrice.toFixed(3))) + " € ", 1))
                                : (__props.product.price)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(convertNumberWithComma)(__props.product.price.toFixed(3))) + " € ", 1))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (__props.product.isSpecialOffer || __props.product.notInStock || __props.product.isPromotion)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                (__props.product.isSpecialOffer)
                                  ? (_openBlock(), _createBlock(HighlightBox, {
                                      key: 0,
                                      color: _unref(HIGHLIGHT_COLOR).PURPLE,
                                      class: "px-2 fs-14 fw-400"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`enumT.${_unref(HIGHLIGHT_MESSAGE).REDUCED}`)), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"]))
                                  : _createCommentVNode("", true),
                                (__props.product.notInStock)
                                  ? (_openBlock(), _createBlock(HighlightBox, {
                                      key: 1,
                                      color: _unref(HIGHLIGHT_COLOR).ORANGE,
                                      class: "px-2 fs-14 fw-400"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`enumT.${_unref(HIGHLIGHT_MESSAGE).NOT_IN_STOCK}`)), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"]))
                                  : _createCommentVNode("", true),
                                (__props.product.isPromotion)
                                  ? (_openBlock(), _createBlock(HighlightBox, {
                                      key: 2,
                                      color: _unref(HIGHLIGHT_COLOR).CORAL,
                                      class: "px-2 fs-14 fw-400"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`enumT.${_unref(HIGHLIGHT_MESSAGE).PROMOTION}`)), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!__props.catalog && !(!__props.catalog && !_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_UPDATE]))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('label.targetStock')) + ":", 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_unref(IonInput), {
                                  label: "",
                                  class: "grey4-grey4-background center purple-purple-color ion-text-center amount-input center-input no-spinner",
                                  style: {"border-radius":"8px","max-width":"80px"},
                                  onClick: select,
                                  onIonInput: saveTargetInput,
                                  disabled: __props.readOnly,
                                  value: __props.targetStock,
                                  inputmode: "numeric",
                                  type: _unref(INPUT_TYPE).NUMBER,
                                  min: "0",
                                  step: "1",
                                  ref_key: "amountInput",
                                  ref: amountInput
                                }, null, 8, ["disabled", "value", "type"])
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (__props.showTags && !Boolean(_unref(persistentStore).offlineMode))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('label.tags')) + ": ", 1),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_23, [
                                  (_unref(requiresPermission)(_unref(PERMISSION_KEY).LIST_UPDATE))
                                    ? (_openBlock(), _createBlock(CategoryPill, {
                                        key: 0,
                                        outline: "",
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('tags'))),
                                        wrap: "",
                                        class: "long-pill"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_24, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('label.editTags')) + " ", 1),
                                            _createVNode(_unref(IonIcon), {
                                              class: "ml-1",
                                              src: "assets/icon/pencil.svg"
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
                                    return (_openBlock(), _createBlock(CategoryPill, {
                                      key: tag.id,
                                      "disable-ripple": "",
                                      class: "light-light-color"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      (!__props.readOnly)
                        ? (_openBlock(), _createBlock(_unref(IonRow), {
                            key: 0,
                            class: "mt-3"
                          }, {
                            default: _withCtx(() => [
                              (!__props.catalog && _unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_DELETE])
                                ? (_openBlock(), _createBlock(_unref(IonCol), {
                                    key: 0,
                                    size: "3",
                                    offset: (!__props.catalog && !_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_UPDATE]) ? '4.5' : '0'
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(ButtonDelete, {
                                        class: "max-size ion-no-margin catalog-delete",
                                        fill: _unref(BUTTON_FILL).OUTLINE,
                                        color: _unref(ION_VARIANT).CORAL,
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('delete')))
                                      }, null, 8, ["fill", "color"])
                                    ]),
                                    _: 1
                                  }, 8, ["offset"]))
                                : _createCommentVNode("", true),
                              (!(!__props.catalog && !_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_UPDATE]))
                                ? (_openBlock(), _createBlock(_unref(IonCol), {
                                    key: 1,
                                    size: fullWidth.value ? '12' : '9',
                                    class: "input-amount-col"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(InputAmount, {
                                        modelValue: amountModel.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((amountModel).value = $event)),
                                        onChange: _cache[3] || (_cache[3] = ($event: any) => (emit('amount', $event))),
                                        "amount-step": __props.product.amountStep
                                      }, null, 8, ["modelValue", "amount-step"])
                                    ]),
                                    _: 1
                                  }, 8, ["size"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!isMultiple.value && !__props.readOnly)
                        ? (_openBlock(), _createBlock(_unref(IonRow), { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), { class: "coral-coral-color fs-small center-x" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('label.multipleAmount', { target: props.product.amountStep ?? 1 })), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!isMax.value && !__props.readOnly)
                        ? (_openBlock(), _createBlock(_unref(IonRow), { key: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), { class: "coral-coral-color fs-small center-x" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('label.maxAmount', { target: props.product.amountMax })), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ((props.catalog || props.buttons) && (_unref(userStore).permission[_unref(PERMISSION_KEY).CART_ADD] || _unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_CREATE]) && !__props.readOnly)
                        ? (_openBlock(), _createBlock(_unref(IonRow), {
                            key: 3,
                            class: "center-x"
                          }, {
                            default: _withCtx(() => [
                              (_unref(userStore).permission[_unref(PERMISSION_KEY).CART_ADD])
                                ? (_openBlock(), _createBlock(_unref(IonCol), {
                                    key: 0,
                                    size: "6",
                                    class: _normalizeClass({'center-x': !_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_CREATE]})
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(ButtonBase, {
                                        color: _unref(ION_VARIANT).CORAL,
                                        class: _normalizeClass(["fw-b wrap-button tt-none", {'mr-2': _unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_CREATE]}]),
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('addCart', { product: __props.product.name, amount: __props.amount }))),
                                        disabled: !isMultiple.value || !isMax.value || Boolean(_unref(persistentStore).offlineMode) || !__props.amount
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('modal.addCart')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color", "class", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true),
                              (_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_ITEM_CREATE])
                                ? (_openBlock(), _createBlock(_unref(IonCol), {
                                    key: 1,
                                    size: "6",
                                    class: _normalizeClass({'center-x': !_unref(userStore).permission[_unref(PERMISSION_KEY).CART_ADD],
                                        'ion-justify-content-end d-flex': _unref(userStore).permission[_unref(PERMISSION_KEY).CART_ADD]
                                })
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(ButtonBase, {
                                        color: _unref(ION_VARIANT).CORAL,
                                        fill: _unref(BUTTON_FILL).OUTLINE,
                                        class: _normalizeClass(["fw-b wrap-button tt-none", {'ml-2': _unref(userStore).permission[_unref(PERMISSION_KEY).CART_ADD]}]),
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('addList', { product: __props.product.name, amount: __props.amount }))),
                                        disabled: !isMultiple.value || !isMax.value || (Boolean(_unref(persistentStore).offlineMode) && !__props.catalog)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('modal.addList')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color", "fill", "class", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (!__props.readOnly && __props.catalog)
                          ? (_openBlock(), _createBlock(_unref(IonRow), { key: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonCol), null, {
                                  default: _withCtx(() => [
                                    _createVNode(ButtonBase, {
                                      color: _unref(ION_VARIANT).CORAL,
                                      class: "fw-b wrap-button tt-none max-width",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('addCart', { product: __props.product.name, amount: __props.amount }))),
                                      disabled: !isMultiple.value || !isMax.value || Boolean(_unref(persistentStore).offlineMode) || !__props.amount
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('modal.addCart')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (!__props.catalog && !__props.readOnly)
                            ? (_openBlock(), _createBlock(_unref(IonRow), { key: 5 }, {
                                default: _withCtx(() => [
                                  (__props.privateSupplier)
                                    ? (_openBlock(), _createBlock(_unref(IonCol), {
                                        key: 0,
                                        class: "center-x"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(ButtonBase, {
                                            color: _unref(ION_VARIANT).CORAL,
                                            class: "fw-b wrap-button tt-none max-width",
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('edit-item')))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('button.edit')), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["color"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_unref(IonCol), { class: "center-x" }, {
                                    default: _withCtx(() => [
                                      _createVNode(ButtonBase, {
                                        color: _unref(ION_VARIANT).CORAL,
                                        class: "fw-b wrap-button tt-none max-width",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(modalController).dismiss()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('button.ok')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]))
    : _createCommentVNode("", true)
}
}

})